import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/Main.vue'
import Login from '@/views/Login.vue';
import { getAuthInfo } from '@/utils/auth';

Vue.use(VueRouter);

//数据统计跳转路径
const resourceUrl = `http://app.zhgylgl.com/owner/index.html?user_id=${localStorage.getItem(
  "userId"
)}`;

//首页路由
const home = [
  {
    path: '/index',
    component: Main,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/MainPage/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  }
]

//数据统计
const resourceData = [
  {
    name: "resource",
    path: resourceUrl,
    hidden: false,
    component: Main,
    meta: {
      title: "数据统计",
      icon: "chart",
      noCache: false,
      link: null
    }
  }
]

//发布正式运单路由
const releasewaybill = [
  {
    name: "releasewaybill",
    path: "/releasewaybill",
    hidden: false,
    component: Main,
    children: [
      {
        path: 'page',
        component: () => import('@/views/MainPage/releaseWaybill'),
        name: 'releasewaybillPage',
        meta: { title: '发布正式运单', icon: 'dashboard', affix: false }
      }
    ]
  }
]

//运单管理路由
const WaybillManagement = [
  {
    name: "WaybillManagement",
    path: "/waybillmanagement",
    hidden: false,
    component: Main,
    meta: {
      title: "运单管理",
      icon: "manage",
      noCache: false,
      link: null
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/MainPage/WaybillManagement/waybillList'),
        name: 'list',
        meta: { title: '运单列表', icon: 'dashboard', affix: false }
      },
      {
        path: 'track',
        component: () => import('@/views/MainPage/WaybillManagement/waybillTrack'),
        name: 'track',
        meta: { title: '运单追踪', icon: 'dashboard', affix: false }
      },
      {
        path: 'delWaybill',
        component: () => import('@/views/MainPage/WaybillManagement/delWaybill'),
        name: 'delWaybill',
        meta: { title: '已删除运单', icon: 'dashboard', affix: false }
      },
      // {
      //   path: 'power',
      //   component: () => import('@/views/MainPage/WaybillManagement/waybillPower'),
      //   name: 'power',
      //   meta: { title: '运力管理', icon: 'dashboard', affix: false }
      // },
      // {
      //   path: 'openTicket',
      //   component: () => import('@/views/MainPage/WaybillManagement/openTicket'),
      //   name: 'openTicket',
      //   meta: { title: '开票记录', icon: 'form', affix: false }
      // },
    ]
  }
]

//财务管理路由
const MoneyManagement = [
  {
    name: "MoneyManagement",
    path: "/moneyManagement",
    hidden: false,
    component: Main,
    meta: {
      title: "财务管理",
      icon: "waybill",
      noCache: false,
      link: null
    },
    children: [
      {
        path: 'payManagement',
        component: () => import('@/views/MainPage/MoneyManagement/payManagement/payManagement'),
        name: 'payManagement',
        meta: { title: '支付管理', icon: 'dashboard', affix: false }
      },
      {
        path: 'payValidate',
        component: () => import('@/views/MainPage/MoneyManagement/payValidate/payValidate'),
        name: 'payValidate',
        meta: { title: '支付结果验证', icon: 'dashboard', affix: false }
      },
      {
        name: "invoiceManage",
        path: "invoiceManage",
        component: () => import('@/views/MainPage/MoneyManagement/invoiceManage/invoiceManage'),
        meta: { title: '发票管理', icon: 'dashboard', affix: false }
      },
      {
        name: "invoiceDetail",
        path: "invoiceDetail",
        component: () => import('@/views/MainPage/MoneyManagement/invoiceDetail/invoiceDetail'),
        meta: { title: '发票明细', icon: 'dashboard', affix: false }
      },
      {
        name: "finaceChange",
        path: "finaceChange",
        component: () => import('@/views/MainPage/MoneyManagement/finaceChange/finaceChange'),
        meta: { title: '资金调拨', icon: 'dashboard', affix: false }
      },
      {
        path: 'moneyRecord',
        component: () => import('@/views/MainPage/MoneyManagement/moneyRecord'),
        name: 'moneyRecordName',
        meta: { title: '充值记录', icon: 'dashboard', affix: false }
      },
      {
        path: 'prePay',
        component: () => import('@/views/MainPage/MoneyManagement/prePay'),
        name: 'prePay',
        meta: { title: '预支付列表', icon: 'dashboard', affix: false }
      },
    ]
  }
]

//货源管理路由
const GoodsManagment = [
  {
    name: "GoodsManagment",
    path: "/goodsManagment",
    hidden: false,
    component: Main,
    meta: {
      title: "货源管理",
      icon: "waybill",
      noCache: false,
      link: null
    },
    children: [
      {
        path: 'release',
        component: () => import('@/views/MainPage/GoodsManagment/release'),
        name: 'release',
        meta: { title: '发布货源', icon: 'dashboard', affix: false }
      },
      {
        path: 'list',
        component: () => import('@/views/MainPage/GoodsManagment/list'),
        name: 'list',
        meta: { title: '货源列表', icon: 'dashboard', affix: false }
      },
      {
        name: "robWaybill",
        path: "robWaybill",
        component: () => import('@/views/MainPage/GoodsManagment/robWaybill'),
        meta: { title: '抢单列表', icon: 'dashboard', affix: false }
      }
    ]
  }
]

//我的钱包路由
const myPocketbook = [
  {
    name: "myPocketbook",
    path: "/myPocketbook",
    hidden: true,
    component: Main,
    children: [
      {
        path: 'page',
        component: () => import('@/views/MainPage/myPocketbook'),
        name: 'myPocketbookPage',
        meta: { title: '我的钱包', icon: 'dashboard', affix: false }
      }
    ]
  }
]

//信息认证路由
const infoAuth = [
  {
    name: "infoAuth",
    path: "/infoAuth",
    hidden: false,
    component: Main,
    meta: {
      title: "信息认证",
      icon: "infoAuth",
      noCache: false,
      link: null
    },
    children: [
      {
        path: 'page',
        component: () => import('@/views/MainPage/infoAuth'),
        name: 'infoAuthPage',
        meta: { title: '信息认证', icon: 'dashboard', affix: false }
      }
    ]
  }
]
//系统设置相关路由
const setting = [
  {
    name: "set",
    path: "/set",
    hidden: false,
    component: Main,
    meta: {
      title: '设置',
      icon: 'system',
      noCache: false,
      link: null
    },
    alwaysShow:true,
    children: [
      {
        path: 'feedback',
        component: () => import('@/views/MainPage/Set/FeedBack/feedback'),
        name: 'feedback',
        meta: { title: '反馈记录', icon: 'documentation', affix: false }
      },
      {
        path: 'evaluate',
        component: () => import('@/views/MainPage/Set/Evaluate/evaluate'),
        name: 'evaluate',
        meta: { title: '评价记录', icon: 'documentation', affix: false }
      },
      {
        path: 'resetPwd',
        component: () => import('@/views/MainPage/Set/ResetPwd/index'),
        name: 'resetpassword',
        meta: { title: '修改密码', icon: 'lock', affix: false }
      },
      {
        path: 'EditPower',
        component: () => import('@/views/MainPage/Set/EditPower/EditPower'),
        name: 'EditPower',
        meta: { title: '修改权限', icon: 'roadLine', affix: false }
      }
    ]
  }
]

//常用地址管理路由
const oftenAddress = [
  {
    name: "oftenAddress",
    path: "/oftenAddress",
    hidden: false,
    component: Main,
    meta: {
      title: "常用地址管理",
      icon: "address",
      noCache: false,
      link: null
    },
    children: [
      {
        path: 'page',
        component: () => import('@/views/MainPage/oftenAddress'),
        name: 'oftenAddressPage',
        meta: { title: '常用地址管理', icon: 'dashboard', affix: false }
      }
    ]
  }
]
let dataScreen;
if(getAuthInfo().company_name != '安阳市诚优建材有限公司'){
  dataScreen = resourceData
}else{
  dataScreen = [];
}


export const routes = [
  {
    path: '/redirect',
    component: Main,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: '/',
    component: Login,
  },
  { path: '*', redirect: '/' },
  ...home,
  // ...resourceData,
  // ...dataScreen,
  ...releasewaybill,
  ...WaybillManagement,
  ...MoneyManagement,
  ...GoodsManagment,
  // ...myPocketbook,
  ...infoAuth,
  ...oftenAddress,
  ...setting,

]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
